import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const CycleCountList = lazy(() => import('./pages/CycleCountList'));
const CycleCountForm = lazy(() => import('./pages/CycleCountForm'));
const CycleCountView = lazy(() => import('./pages/CycleCountView'));
const CyclePeriodList = lazy(() => import('./pages/CyclePeriodList'));
const CyclePeriodForm = lazy(() => import('./pages/CyclePeriodForm'));
const StockTakingPage = lazy(() => import('./pages/StockTakingPage'));
const StockTakingList = lazy(() => import('./pages/StockTakingList'));
const AdminReviewPage = lazy(() => import('./pages/AdminReviewPage'));
const StockAdjustmentPage = lazy(() => import('./pages/StockAdjustmentPage'));
const CycleReportPage = lazy(() => import('./pages/CycleReportPage'));
const RetakeScanPage = lazy(() => import('./pages/RetakeScanPage'));

const cycleCountRoutes: RouteObject[] = [
  {
    path: 'cycle-counts',
    element: <CycleCountList />,
  },
  {
    path: 'cycle-counts/create',
    element: <CycleCountForm />,
  },
  {
    path: 'cycle-counts/:id',
    element: <CycleCountView />,
  },
  {
    path: 'cycle-counts/:id/edit',
    element: <CycleCountForm />,
  },
  {
    path: 'periods',
    element: <CyclePeriodList />,
  },
  {
    path: 'periods/create',
    element: <CyclePeriodForm />,
  },
  {
    path: 'periods/:id',
    element: <CyclePeriodForm />,
  },
  {
    path: 'periods/:id/stock-taking',
    element: <StockTakingPage />,
  },
  {
    path: 'periods/:id/review',
    element: <AdminReviewPage />,
  },
  {
    path: 'periods/:id/adjustment',
    element: <StockAdjustmentPage />,
  },
  {
    path: 'stock-taking',
    element: <StockTakingList />,
  },
  {
    path: 'retakes/:retakeId',
    element: <RetakeScanPage />,
  },
  {
    path: 'reports',
    element: <CycleReportPage />,
  },
];

export default cycleCountRoutes;
